import { matchPath } from 'react-router-dom';

import { ROUTES_MATCH_PATHS } from '../pages/personal-information/utils';
import { ONBOARDING_FIRST_STEPS_URL } from '../utils/urls';

const usePersonalInformationSteps = (currentPathName) => {
  const { companyInformation, liablePartner, logisticAddress } = ROUTES_MATCH_PATHS;
  const stepRoutesInOrder = [logisticAddress, companyInformation, liablePartner];
  const totalSteps = stepRoutesInOrder.length;

  const { currentStep, nextStepPath } = stepRoutesInOrder.reduce(
    (previousValue, route, index) => {
      const doCurrentPathMatches = matchPath(currentPathName, route.path);

      if (doCurrentPathMatches && doCurrentPathMatches?.isExact) {
        return {
          currentStep: index + 1,
          nextStepPath: stepRoutesInOrder[index + 1]?.path[0] ?? ONBOARDING_FIRST_STEPS_URL,
        };
      }

      return previousValue;
    },
    { currentStep: 0, nextStepPath: ONBOARDING_FIRST_STEPS_URL }
  );

  return { currentStep, totalSteps, nextStepPath };
};

export default usePersonalInformationSteps;
